export default {
    name: 'CheckboxDouble',
    dimensions: { width: 41, height: 40 },
    content: `
    <g fill="none" stroke="currentColor" clip-path="url(#clip0_27_1773)">
    <path d="M31.9927 39.003H9.99268C5.58268 39.003 1.99268 35.413 1.99268 31.003V9.00296C1.99268 4.59296 5.58268 1.00296 9.99268 1.00296H31.9927C36.4027 1.00296 39.9927 4.59296 39.9927 9.00296V31.003C39.9927 35.413 36.4027 39.003 31.9927 39.003ZM9.99268 5.00296C7.78268 5.00296 5.99268 6.79296 5.99268 9.00296V31.003C5.99268 33.213 7.78268 35.003 9.99268 35.003H31.9927C34.2027 35.003 35.9927 33.213 35.9927 31.003V9.00296C35.9927 6.79296 34.2027 5.00296 31.9927 5.00296H9.99268Z" stroke-width="2" stroke-linecap="round"/>
    <path d="M28.4027 14.593C27.6227 13.813 26.3527 13.813 25.5727 14.593L18.9927 21.173L16.4127 18.593C15.6327 17.813 14.3627 17.813 13.5827 18.593C12.8027 19.373 12.8027 20.643 13.5827 21.423L17.5827 25.423C17.9727 25.813 18.4827 26.013 18.9927 26.013C19.5027 26.013 20.0127 25.813 20.4027 25.423L28.4027 17.423C29.1827 16.643 29.1827 15.373 28.4027 14.593V14.593Z" stroke-width="2" stroke-linecap="round"/>
    </g>
    <defs>
    <clipPath id="clip0_27_1773">
    <rect width="40" height="40" fill="none" transform="translate(0.992676 0.00296021)"/>
    </clipPath>
    </defs>
  `
};
